// Sezione offerte agenti per Admin (solleciti)
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { AlertTriangle } from 'lucide-react';

const AgentOffersSection = ({ 
  agentOffers, 
  showAgentOffers, 
  setShowAgentOffers, 
  onSendSollecito 
}) => {
  if (!agentOffers || agentOffers.length === 0) return null;

  return (
    <Card className="border-orange-200">
      <CardHeader className="cursor-pointer" onClick={() => setShowAgentOffers(!showAgentOffers)}>
        <CardTitle className="flex items-center justify-between" style={{ fontFamily: 'Plus Jakarta Sans' }}>
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-orange-500" />
            <span>Offerte Rete Vendita</span>
            <Badge className="bg-orange-100 text-orange-700 ml-2">
              {agentOffers.length} da monitorare
            </Badge>
          </div>
          <Button variant="ghost" size="sm">
            {showAgentOffers ? 'Nascondi' : 'Mostra'}
          </Button>
        </CardTitle>
      </CardHeader>
      {showAgentOffers && (
        <CardContent>
          <p className="text-sm text-slate-500 mb-4">
            Queste sono le offerte degli agenti non ancora in fase avanzata. Puoi sollecitare un aggiornamento sull&apos;esito.
          </p>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Cliente</TableHead>
                  <TableHead>Agente</TableHead>
                  <TableHead>Veicolo</TableHead>
                  <TableHead>Canone</TableHead>
                  <TableHead>Esito</TableHead>
                  <TableHead className="text-right">Azioni</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {agentOffers.map(offer => (
                  <TableRow key={offer.id} className={offer.sollecito_admin ? 'bg-orange-50' : ''}>
                    <TableCell>
                      <p className="font-medium">{offer.contact_info?.nome_cognome || 'N/A'}</p>
                    </TableCell>
                    <TableCell>
                      <span className="text-slate-600">{offer.user_name}</span>
                    </TableCell>
                    <TableCell>
                      <p className="text-sm">
                        {offer.vehicle_info?.marca} {offer.vehicle_info?.modello}
                      </p>
                    </TableCell>
                    <TableCell>
                      <span className="font-medium">€{offer.canone_finale?.toLocaleString('it-IT', { minimumFractionDigits: 0 })}</span>
                    </TableCell>
                    <TableCell>
                      {offer.sollecito_admin ? (
                        <Badge className="bg-orange-100 text-orange-700 animate-pulse">
                          Sollecitato
                        </Badge>
                      ) : (
                        <Badge variant="outline">
                          {offer.esito || 'Da esitare'}
                        </Badge>
                      )}
                    </TableCell>
                    <TableCell className="text-right">
                      {!offer.sollecito_admin ? (
                        <Button 
                          size="sm"
                          className="bg-orange-500 hover:bg-orange-600"
                          onClick={() => onSendSollecito(offer.id)}
                        >
                          <AlertTriangle className="w-4 h-4 mr-1" />
                          Richiedi Esito
                        </Button>
                      ) : (
                        <span className="text-xs text-orange-600">
                          Inviato il {new Date(offer.sollecito_at).toLocaleDateString('it-IT')}
                        </span>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default AgentOffersSection;
